import {
	ChangeDetectorRef,
	Component,
	OnInit,
	ViewChild,
	Input,
} from "@angular/core";
import { CommonHelper } from "../../../../../../../app/utilities/common.helper";
import { HecResponse } from "../../../../../../../app/shared/shared-interfaces/hecResponse";
import { PucaPACModel, PucaTestModel } from "./Model/puca-pac.model";
import { PucaPacService } from "./Service/puca-pac.service";
import { NgForm } from "@angular/forms";
import {
	GREScore,
	HATScore,
} from "../puca-questionnaire/model/puca-questionnaire-model";
import { PucaFormService } from "../puca-form.service";
import { Router } from "@angular/router";
import { decrypt } from "../../../../../../../../src/app/utilities/utilityFunctions";
import { HEC_CONSTANTS } from "../../../../../../../../src/app/utilities/constants";

@Component({
	selector: "kt-puca-professional-accomplishment",
	templateUrl: "./puca-professional-accomplishment.component.html",
	styleUrls: ["./puca-professional-accomplishment.component.scss"],
})
export class PucaProfessionalAccomplishmentComponent implements OnInit {
	public pacModel: PucaPACModel = new PucaPACModel();
	public alertClass: string;
	public alertIcon: string;
	public alertMsgValue: string;
	public isAlertVisible: boolean = false;
	@ViewChild("pacform", { static: false }) pacForm: NgForm;
	public admissionWTSupport: boolean = false;
	@ViewChild("gre", { static: false }) gre: any;
	@Input() pucaApplication: any;
	GRE: GREScore = new GREScore();
	GMAT: PucaTestModel = new PucaTestModel();
	TOEFL: PucaTestModel = new PucaTestModel();
	IELTS: PucaTestModel = new PucaTestModel();
	HAT: HATScore = new HATScore();

	@Input() isAdmin: boolean = false;
	@Input("formType") formType: string;
	applicationFormData: any;
	@Input("dropdownList") dropdownList: any = {};
	isHattotalError: boolean;
	istotalError: boolean;
	totalErrorMessage: string;
	isGMATtotalError: boolean;
	isTOEFLtotalError: boolean;
	isIELTStotalError: boolean;
	constructor(
		private pacService: PucaPacService,
		private cdr: ChangeDetectorRef,
		private router: Router,
		private pucaFormService: PucaFormService
	) {
		this.pucaFormService.setNewPucaApplication.subscribe((v) => {
			this.pucaApplication = v;
			this.EditPucaForm();
		});
	}

	ngOnInit() {
		this.isAlertVisible = false;
	}

	getApplicationData() {
		this.isAlertVisible = false;
		const profile = JSON.parse(
			decrypt(localStorage.getItem("esp-profile-details"))
		);
		this.pucaFormService
			.getApplicationFormData(
				this.pucaApplication
					? this.pucaApplication.pucaApplicationDto.id
					: 0,
				this.pucaApplication
					? this.pucaApplication.pucaApplicationDto.commonProfileId
					: profile["profileId"]
			)
			.subscribe(
				(res: HecResponse) => {
					if (res.code == 0 || res.statusCode == 200) {
						this.applicationFormData = res.result
							? res.result
							: res.data;
						this.dropdownList["TestCenterList"] =
							this.applicationFormData.preferredTestCenterList;
						this.cdr.detectChanges();
					} else {
					}
				},
				(err) => {}
			);
	}

	ngAfterViewInit(): void {
		//EDIT MODE :START
		this.EditPucaForm();
		this.getApplicationData();
		// EDIT MODE: END
	}

	private EditPucaForm() {
		this.isAlertVisible = false;
		if (this.pucaApplication) {
			const pucaApplication = this.pucaApplication.pucaApplicationDto;

			pucaApplication.isTutionFeeWaiver == true
				? this.setTutionFeeWaiver("1")
				: this.setTutionFeeWaiver("2");
			if (
				pucaApplication.categoryTypeId &&
				pucaApplication.categoryTypeId == "32251"
			) {
				//THIRD QUESTION SELECTED
				this.admissionWTSupport = true;
				this.pacModel.isGreSelected = false;
			} else if (
				pucaApplication.categoryTypeId &&
				pucaApplication.categoryTypeId == "32255"
			) {
				//FIRST QUESTION SELECTED
				this.admissionWTSupport = true;
				this.pacModel.isGreSelected = true;
			} else if (
				pucaApplication.categoryTypeId &&
				pucaApplication.categoryTypeId == "32252"
			) {
				//SECOND QUESTION SELECTED
				this.admissionWTSupport = true;
				this.pacModel.isGreSelected = true;
			} else if (
				pucaApplication.categoryTypeId &&
				pucaApplication.categoryTypeId == "32253"
			) {
				//FIFTH QUESTION SELECTED
				this.admissionWTSupport = true;
				this.pacModel.isGreSelected = true;
			} else if (
				pucaApplication.categoryTypeId &&
				pucaApplication.categoryTypeId == "32254"
			) {
				//NO QUESTION SELECTED
				this.admissionWTSupport = true;
				this.pacModel.isGreSelected = false;
			}

			if (pucaApplication.isGre) {
				// IF GRE SET
				const preferences = this.pucaApplication.pucaGreDtoList[0];
				this.pacModel.isGreSelected = true;
				this.cdr.detectChanges();
				this.GRE = new GREScore();
				this.GRE.TestDate = new Date(preferences.date).toISOString();
				this.GRE.VerbalReasoning = preferences.verbalScore;
				this.GRE.QuantitativeReasoning = preferences.quantitativeScore;
				this.GRE.AnalyticalWriting = preferences.analyticalScore;
			}
			if (pucaApplication.isTutionFeeWaiver == undefined) {
				this.setTutionFeeWaiver("2");
				console.log("undefined");
			} else if (pucaApplication.isTutionFeeWaiver == true) {
				this.setTutionFeeWaiver("1");
			} else if (pucaApplication.isTutionFeeWaiver == false) {
				this.setTutionFeeWaiver("2");
			}

			const pucaHat = this.pucaApplication.pucaHatDtoList[0];

			if (pucaApplication.isHat) {
				// IF GRE SET
				if (pucaHat && pucaHat.preferredTestCenterId) {
					this.setHasHat("2");
					this.pacModel.isHatAvailable = "2";
					const preferences = this.pucaApplication.pucaHatDtoList[0];
					this.cdr.detectChanges();
					this.HAT = new HATScore();
					this.HAT.TestCentre = preferences.preferredTestCenterId;
				} else if (
					pucaHat &&
					pucaHat.registrationNumber &&
					pucaHat.obtainedScore &&
					pucaHat.totalScore
				) {
					this.setHasHat("1");
					this.pacModel.isHatAvailable = "1";
					const preferences = this.pucaApplication.pucaHatDtoList[0];
					this.cdr.detectChanges();
					this.HAT = new HATScore();
					this.HAT.TestDate = preferences.testDate
						? new Date(preferences.testDate).toISOString()
						: null;
					this.HAT.TotalScoreObtained = preferences.totalScore;
					this.HAT.PercentageObtained = preferences.obtainedScore;
					this.HAT.RegistrationNumber =
						preferences.registrationNumber;
				} else this.setHasHat("0");
			} else if (pucaHat && pucaHat.preferredTestCenterId) {
				this.setHasHat("2");
				this.pacModel.isHatAvailable = "2";
				const preferences = this.pucaApplication.pucaHatDtoList[0];
				this.cdr.detectChanges();
				this.HAT = new HATScore();
				this.HAT.TestCentre = preferences.preferredTestCenterId;
			} else this.setHasHat("0");

			if (
				this.pucaApplication.pucaTestDtoList &&
				this.pucaApplication.pucaTestDtoList.length > 0
			) {
				for (
					let i = 0;
					i < this.pucaApplication.pucaTestDtoList.length;
					i++
				) {
					const test = this.pucaApplication.pucaTestDtoList[i];

					if (
						test.testTypeCodeId == 30964 &&
						pucaApplication.isGmat
					) {
						//30964 GMAT
						this.pacModel.isGMATSelected = true;
						this.GMAT.testDate = new Date(
							test.testDate
						).toISOString();
						this.GMAT.totalScore = test.totalScore;
						this.GMAT.obtainedScore = test.obtainedScore;
					}
					if (
						test.testTypeCodeId == 30961 &&
						pucaApplication.isToefl
					) {
						//30961 TOFL
						this.pacModel.isTOEFELSelected = true;
						this.TOEFL.testDate = new Date(
							test.testDate
						).toISOString();
						this.TOEFL.totalScore = test.totalScore;
						this.TOEFL.obtainedScore = test.obtainedScore;
					}
					if (
						test.testTypeCodeId == 30966 &&
						pucaApplication.isIelts
					) {
						//30966 IELTS
						this.pacModel.isIELTSSelected = true;
						this.IELTS.testDate = new Date(
							test.testDate
						).toISOString();
						this.IELTS.totalScore = test.totalScore;
						this.IELTS.obtainedScore = test.obtainedScore;
					}
				}
			}
		}
	}

	public async savePac() {
		this.isAlertVisible = false;
		const pucaApplication = this.pucaApplication.pucaApplicationDto;
		if (this.formType == "view") {
			this.pucaFormService.nextStep.next(true);
			return false;
		}

		if (this.admissionWTSupport == true) {
			if (this.pacModel.isTutionFeeWaiver == "0") {
				this.alertBoxMsg("Answer to all the questions is mandatory");
				this.isAlertVisible = true;
				this.cdr.detectChanges();
				return false;
			}
			if (
				this.pacModel.isTutionFeeWaiver != "1" &&
				this.pacModel.isHatAvailable === "1"
			) {
				let percentage =
					(Number(this.pacForm.value.HatScore) /
						Number(this.pacForm.value.HatTotalScore)) *
					100;
				if (percentage < 60) {
					this.alertBoxMsg("60% score in HAT is mandatory");
					this.isAlertVisible = true;
					this.cdr.detectChanges();
					return false;
				}
			}

			// if (this.pacModel.isGreSelected == true)
			// {
			// 	const total = Number(this.GRE.VerbalReasoning) + Number(this.GRE.QuantitativeReasoning)
			// 	let percentage = total * 100 / 340;
			// 	console.log("gre",percentage)
			// 	if(percentage < 60)
			// 	{
			// 		this.alertBoxMsg('60% score in GRE is mandatory');
			// 		this.isAlertVisible = true;
			// 		this.cdr.detectChanges();
			// 		return false;
			// 	}
			// }

			if (this.pacModel.isGreSelected == false) {
				console.log(pucaApplication.categoryTypeId);
				if (pucaApplication.categoryTypeId == "32253") {
					this.alertBoxMsg("GRE is Mandatory");
					this.isAlertVisible = true;
					this.cdr.detectChanges();
					return false;
				} else if (
					pucaApplication.categoryTypeId == "32255" ||
					pucaApplication.categoryTypeId == "32252"
				) {
					if (
						this.pacModel.isTutionFeeWaiver != "1" &&
						(this.pacModel.isHatAvailable === "0" ||
							this.pacModel.isHatAvailable === "2")
					) {
						this.alertBoxMsg("GRE OR HAT is Mandatory");
						this.isAlertVisible = true;
						this.cdr.detectChanges();
						return false;
					}
					// else if (Number(this.pacModel.isHatAvailable) > 0) {
					// 	if (//!this.pacForm.value.HATPreferredCentere &&
					// 		 !Number(this.pacForm.value.HatTotalScore)) {
					// 		this.alertBoxMsg('Kindly filled all the required fields');
					// 		this.isAlertVisible = true;
					// 		this.cdr.detectChanges();
					// 		return false;
					// 	}
					// }
				}
			}
		}

		this.markFormsTouched(this.pacForm);

		if (this.validate(this.pacForm)) {
			if (this.isHattotalError) return;
			const payload: any = {
				data: {},
			};
			const profile = JSON.parse(
				decrypt(localStorage.getItem("esp-profile-details"))
			);

			payload.data.id = pucaApplication.id;
			payload.data.configScholarshipId = 109;
			payload.data.commonProfileId = profile["profileId"];

			payload.data.isGre = false;
			payload.data.isHat = false;
			payload.data.isGmat = false;
			payload.data.isToefl = false;
			payload.data.isIelts = false;
			payload.data.isTutionFeeWaiver = false; //to be changed

			if (this.GRE && Number(this.GRE.AnalyticalWriting) > 0) {
				payload.data.isGre = true;
				payload.data.pucaGreDtoList = [
					{
						date: this.GRE.TestDate,
						verbalScore: Number(this.GRE.VerbalReasoning),
						quantitativeScore: Number(
							this.GRE.QuantitativeReasoning
						),
						analyticalScore: Number(this.GRE.AnalyticalWriting),
					},
				];
			}

			if (payload.data.isGre)
				payload.data.isGre = this.pacModel.isGreSelected;

			if (
				this.admissionWTSupport == true &&
				this.pacModel.isTutionFeeWaiver != "1" &&
				this.pacModel.isHatAvailable === "1"
			) {
				payload.data.isHat = true;
				payload.data.pucaHatDtoList = [
					{
						testDate: new Date(
							this.pacForm.value.HatTestDate
						).getTime(),
						totalScore: Number(this.pacForm.value.HatTotalScore),
						obtainedScore: Number(this.pacForm.value.HatScore),
						registrationNumber: this.pacForm.value.HatRegNumber,
						percentage:
							(Number(this.pacForm.value.HatScore) /
								Number(this.pacForm.value.HatTotalScore)) *
							100,
					},
				];
			}
			// else {
			// 	payload.data.pucaHatDtoList = [
			// 		{
			// 			"preferredTestCenterId": this.pacForm.value.HATPreferredCentere
			// 		}
			// 	];
			// }

			payload.data.isTutionFeeWaiver =
				this.pacModel.isTutionFeeWaiver == "1"; //to be changed
			if (payload.data.isHat)
				payload.data.isHat = this.pacModel.isHatAvailable == "1";

			payload.data.pucaTestDtoList = [];
			if (this.pacModel.isGMATSelected == true) {
				//30964 GMAT
				payload.data.isGmat = true;
				payload.data.pucaTestDtoList.push({
					testTypeCodeId: 30964,
					testDate: this.GMAT.testDate,
					totalScore: Number(this.GMAT.totalScore),
					obtainedScore: Number(this.GMAT.obtainedScore),
					percentile:
						(Number(this.GMAT.obtainedScore) /
							Number(this.GMAT.totalScore)) *
						100,
				});
			}

			if (payload.data.isGmat)
				payload.data.isGmat = this.pacModel.isGMATSelected;

			if (this.pacModel.isTOEFELSelected == true) {
				//30961 TOFel
				payload.data.isToefl = true;
				payload.data.pucaTestDtoList.push({
					testTypeCodeId: 30961,
					testDate: this.TOEFL.testDate,
					totalScore: Number(this.TOEFL.totalScore),
					obtainedScore: Number(this.TOEFL.obtainedScore),
					percentile:
						(Number(this.TOEFL.obtainedScore) /
							Number(this.TOEFL.totalScore)) *
						100,
				});
			}

			if (payload.data.isToefl)
				payload.data.isToefl = this.pacModel.isTOEFELSelected;

			if (this.pacModel.isIELTSSelected == true) {
				//30966 IELTS
				payload.data.isIelts = true;
				payload.data.pucaTestDtoList.push({
					testTypeCodeId: 30966,
					testDate: this.IELTS.testDate,
					totalScore: Number(this.IELTS.totalScore),
					obtainedScore: Number(this.IELTS.obtainedScore),
					percentile:
						(Number(this.IELTS.obtainedScore) /
							Number(this.IELTS.totalScore)) *
						100,
				});
			}

			if (payload.data.isIelts)
				payload.data.isIelts = this.pacModel.isIELTSSelected;

			return new Promise((resolve, reject) => {
				this.pacService.saveApplication(payload).subscribe(
					(res: HecResponse) => {
						if (res.code == 0) {
							resolve(res.result);

							this.pucaFormService.nextStep.next(true);
							this.cdr.detectChanges();
						} else {
							reject(null);
						}
					},
					(err) => {
						reject(null);
					}
				);
			}).catch(function (error) {});
		} else {
			if (this.findInvalidControls().length > 0) {
				this.alertBoxMsg(
					"Please fill all the mandatory fields with valid data"
				);
				this.isAlertVisible = true;
				this.cdr.detectChanges();
			}
		}
	}

	setHasHat = (e) => {
		console.log("hat", e);
		this.isAlertVisible = false;
		this.pacModel.isHatAvailable = e;

		if (this.pacModel.isHatAvailable == "2") {
			this.HAT.TestDate = null;
			this.HAT.TotalScoreObtained = null;
			this.HAT.PercentageObtained = null;
			this.HAT.RegistrationNumber = null;
		}
	};
	setTutionFeeWaiver = (e) => {
		console.log("feeWaiver", e);
		this.isAlertVisible = false;
		this.pacModel.isTutionFeeWaiver = e;
	};

	validate = (f) => {
		if (f.status === "VALID") {
			return true;
		}
	};

	findInvalidControls = () => {
		const invalid = [];
		const controls = this.pacForm.controls;
		for (const name in controls) {
			if (controls[name].invalid) {
				invalid.push(name);
			}
		}
		return invalid;
	};

	alertBoxMsg = (message, alertType?) => {
		if (alertType == "success") {
			this.alertClass =
				"alert alert-solid-success alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fa fa-check-circle";
		} else if (alertType == "warning") {
			this.alertClass =
				"alert alert-solid-warning alert-bold fade show kt-margin-t-20 kt-margin-b-40";
			this.alertIcon = "fas fa-exclamation-circle";
		} else {
			this.alertClass =
				"alert alert-solid-danger alert-bold fade show kt-margin-t-20 kt-margin-b-20";
			this.alertIcon = "fa fa-exclamation-triangle";
		}
		this.alertMsgValue = message;
	};

	markFormsTouched = (form) => {
		CommonHelper.markFormGroupTouched(form);
	};

	greChangeEvent = (e) => {
		this.isAlertVisible = false;
		this.pacModel.isGreSelected = e.checked;
		console.log(this.pacModel.isGreSelected);

		if (!this.pacModel.isGreSelected) {
			this.GRE.TestDate = null;
			this.GRE.VerbalReasoning = null;
			this.GRE.QuantitativeReasoning = null;
			this.GRE.AnalyticalWriting = null;
		}

		// if (!this.pacModel.isGreSelected) {
		// 	this.pacModel.isTOEFELSelected = e.checked;
		// 	this.pacModel.isGMATSelected = e.checked;
		// 	this.pacModel.isIELTSSelected = e.checked;
		// }
	};

	gmatChangeEvent = (e) => {
		this.isAlertVisible = false;
		this.pacModel.isGMATSelected = e.checked ? true : false;
		if (!this.pacModel.isGMATSelected) {
			this.GMAT.testDate = null;
			this.GMAT.totalScore = null;
			this.GMAT.obtainedScore = null;
		}
	};
	toefelChangeEvent = (e) => {
		this.isAlertVisible = false;
		this.pacModel.isTOEFELSelected = e.checked ? true : false;
		if (!this.pacModel.isTOEFELSelected) {
			this.TOEFL.testDate = null;
			this.TOEFL.totalScore = null;
			this.TOEFL.obtainedScore = null;
		}
	};
	ieltsChangeEvent = (e) => {
		this.isAlertVisible = false;
		this.pacModel.isIELTSSelected = e.checked ? true : false;
		if (!this.pacModel.isIELTSSelected) {
			this.IELTS.testDate = null;
			this.IELTS.totalScore = null;
			this.IELTS.obtainedScore = null;
		}
	};
	getNextDisabled = () =>
		(this.admissionWTSupport && this.pacModel.isHatAvailable === "0") ||
		(!this.admissionWTSupport && !this.pacModel.isGreSelected);

	public goBack() {
		this.pucaFormService.previousStep.next(true);
		this.cdr.detectChanges();
	}

	public cancelAttestaion() {
		if (this.isAdmin) {
			this.router.navigate(["/admin-dashboard/PAK-US-Admnin-Dashboard"]);
		} else {
			this.router.navigate(["/"]);
		}
	}

	dateChangedGRE(e) {
		this.isAlertVisible = false;
		this.GRE.TestDate = e;
	}

	dateChangedGMAT(e) {
		this.isAlertVisible = false;
		this.GMAT.testDate = e;
	}

	dateChangedHAT(e) {
		this.isAlertVisible = false;
		this.HAT.TestDate = e;
	}

	dateChangedIELTS(e) {
		this.isAlertVisible = false;
		this.IELTS.testDate = e;
	}

	dateChangedTOEFL(e) {
		this.isAlertVisible = false;
		this.TOEFL.testDate = e;
	}
	changedTestCentre(e) {
		this.isAlertVisible = false;
		this.HAT.TestCentre = e;
	}

	public calcHatPerc() {
		this.isHattotalError = false;
		const obtainedScore = Number(this.HAT.PercentageObtained);
		const totalScore = Number(this.HAT.TotalScoreObtained);
		if (obtainedScore > totalScore) {
			this.HAT.PercentageObtained = "0";

			this.isHattotalError = true;
		}
	}

	public hatObtainedMarksChanged(event) {
		this.HAT.PercentageObtained = event.target.value;
		this.calcHatPerc();
	}

	public hatTotalMarksChanged(event) {
		this.HAT.TotalScoreObtained = event.target.value;
		this.calcHatPerc();
	}

	public calculateTotalAndPercentage() {
		this.istotalError = false;
		const total =
			Number(this.GRE.VerbalReasoning) +
			Number(this.GRE.QuantitativeReasoning);
		if (total > 340) {
			this.GRE.VerbalReasoning = "0";
			this.GRE.QuantitativeReasoning = "0";
			this.istotalError = true;
			this.totalErrorMessage = "Total Shouldn't be greater than 340";
			return false;
		}
	}

	public GMATObtainedMarksChanged(event) {
		this.isGMATtotalError = false;
		const obtainedScore = Number(this.GMAT.obtainedScore);
		const totalScore = Number(this.GMAT.totalScore);
		if (obtainedScore > totalScore) {
			this.GMAT.obtainedScore = 0;

			this.isGMATtotalError = true;
		}
	}

	public TOEFLObtainedMarksChanged(event) {
		this.isAlertVisible = false;
		this.isTOEFLtotalError = false;
		const obtainedScore = Number(this.TOEFL.obtainedScore);
		const totalScore = Number(this.TOEFL.totalScore);
		if (obtainedScore > totalScore) {
			this.TOEFL.obtainedScore = 0;

			this.isTOEFLtotalError = true;
		}
	}

	public IELTSObtainedMarksChanged(event) {
		this.isAlertVisible = false;
		this.isIELTStotalError = false;
		const obtainedScore = Number(this.IELTS.obtainedScore);
		const totalScore = Number(this.IELTS.totalScore);
		if (obtainedScore > totalScore) {
			this.IELTS.obtainedScore = 0;

			this.isIELTStotalError = true;
		}
	}
}
